import React from "react"
import { ErrorMessage, FieldArray, FormikProps } from "formik"
import clsx from "clsx"
import { CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM } from "@common-constants/*"

export const NdfGroupedJustificatifsSection = ({ helpers }: { helpers: FormikProps<any> }) => {
     // Check if all selected categories in the grouped items are KM
     const isAllKm = helpers.values.childs.every((child: any) => child.categorie === CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM)

     return (
          <div className="card shadow-sm border border-gray-300 h-100">
               <div className="card-header border-bottom bg-light">
                    <h3 className="card-title align-items-start flex-column pt-4">
                         <span className={clsx("fw-boldest fs-4 mb-1", !isAllKm && "required")}>Justificatifs</span>
                         <span className="text-muted fs-8 fw-bold">Formats : PDF, JPG, PNG (Max 10MB)</span>
                    </h3>
               </div>
               <div className="card-body">
                    <FieldArray name={"fichiers"}>
                         {({ push, remove }) => (
                              <div className="d-flex flex-column gap-4">
                                   {helpers.values.fichiers.map((_, index: number) => (
                                        <div className="p-4 bg-light-primary bg-opacity-25 border border-primary border-dashed rounded-3 transition-all" key={index}>
                                             <div className="d-flex align-items-center">
                                                  <div className="symbol symbol-45px me-3 flex-shrink-0">
                                                       <div className="symbol-label bg-white shadow-sm">
                                                            <i className="fas fa-cloud-upload-alt text-primary fs-3"></i>
                                                       </div>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                       <input
                                                            type={"file"}
                                                            name={`fichiers[${index}]`}
                                                            onChange={e =>
                                                                 helpers.setFieldValue(`fichiers[${index}]`, e.target.files && e.target.files.length > 0 ? e.target.files[0] : null)
                                                            }
                                                            className={"form-control form-control-sm form-control-solid bg-white"}
                                                       />
                                                  </div>
                                                  {index > 0 && (
                                                       <button
                                                            className="btn btn-icon btn-sm btn-light-danger shadow-sm hover-elevate-up ms-3 flex-shrink-0"
                                                            type="button"
                                                            onClick={() => remove(index)}
                                                       >
                                                            <i className="fas fa-times fs-6"></i>
                                                       </button>
                                                  )}
                                             </div>
                                             <ErrorMessage name={`fichiers[${index}]`}>
                                                  {msg => (
                                                       <div className="text-danger fs-8 fw-bold mt-3 bg-light-danger p-2 rounded">
                                                            <i className="fas fa-exclamation-triangle me-1 text-danger"></i>
                                                            {msg}
                                                       </div>
                                                  )}
                                             </ErrorMessage>
                                        </div>
                                   ))}

                                   <button
                                        className="btn btn-light-primary btn-sm fw-boldest border border-primary border-dashed mt-2 py-3 hover-elevate-up"
                                        type="button"
                                        onClick={() => push({ isAllerRetour: false })}
                                   >
                                        <i className="fas fa-plus-circle me-2 fs-5" /> Ajouter un autre justificatif
                                   </button>
                              </div>
                         )}
                    </FieldArray>
               </div>
          </div>
     )
}
